<h2 mat-dialog-title *ngIf="data.title">{{ data.title }}</h2>

<mat-dialog-content class="dialog-content">
    <p *ngIf="data.description" class="dialog-description">{{ data.description }}</p>

    <app-alert-box *ngIf="preferredPharmacy" type="info" [label]="'Preferred Pharmacy'" [message]="preferredPharmacy">
    </app-alert-box>

    <mat-form-field class="full-width" appearance="outline">
        <mat-label>Search a Pharmacy</mat-label>
        <input matInput type="text" placeholder="e.g., Medmate" [formControl]="locationSearchTerm"
            [matAutocomplete]="auto" />
        <mat-spinner matSuffix *ngIf="searching" diameter="20"></mat-spinner>
        <button *ngIf="!searching && selectedPharmacy" matSuffix mat-icon-button aria-label="Clear" matTooltip="Clear"
            (click)="clearSelection()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPharmacy($event.option.value)"
        [displayWith]="displayFn">
        <ng-container *ngIf="(filteredPharmacies$ | async) as pharmacies">
            <mat-option *ngFor="let pharmacy of pharmacies" [value]="pharmacy" class="height-auto">
                <div class="option-content">
                    <div class="option-title">{{ pharmacy.locationid }} - {{ pharmacy.locationname }}</div>
                    <div class="option-subtext">{{ pharmacy.address }}</div>
                </div>
            </mat-option>

            <mat-option *ngIf="showCreateNewStoreOption" disabled>
                <div class="no-results">
                    <strong>No pharmacies found for:</strong>
                    <em>"{{ locationSearchTerm.value }}"</em>
                </div>
            </mat-option>

            <mat-option *ngIf="showCreateNewStoreOption" (onSelectionChange)="redirectToCreateStore()" [value]="null">
                <mat-icon color="primary">open_in_new</mat-icon>
                <strong>Create new store</strong>
            </mat-option>
        </ng-container>
    </mat-autocomplete>

    <app-alert-box *ngIf="isEmailMissing" type="error" [message]="alertMessage" ctaLabel="Add Email"
        (ctaClick)="goToStore()">
    </app-alert-box>
    <app-alert-box *ngIf="selectedPharmacy?.email && data.showEmail" type="info" label="Selected Pharmacy Email"
        [message]="selectedPharmacy?.email">
    </app-alert-box>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()">Cancel</button>
    <button mat-flat-button color="accent" class="mm-text-white" [disabled]="!selectedPharmacy || isEmailMissing"
        (click)="confirmSelection()">
        {{data?.confirmLabel?? 'Confirm'}}
    </button>
</mat-dialog-actions>